module.exports = __webpack_public_path__ + "img/3.69992f47.png";